module.exports = __webpack_public_path__ + "img/act_pro_img17s_03.09b5ed05.png";